var _defs, _g, _g2, _ellipse, _rect, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginGame1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "login",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1921.98,
    height: 1315.32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1921.98 1315.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.5,
    y1: 1080,
    x2: 1.5,
    y2: 1081,
    gradientTransform: "translate(-1922.8 641905.32) scale(1921.98 -593.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fcadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bd3e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33acc2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.5,
    y1: 1083.85,
    x2: 1.5,
    y2: 1083.86,
    gradientTransform: "translate(-1922.8 547671.15) scale(1921.98 -506.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33acc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249bab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1.51,
    cy: 1081,
    fx: 1.51,
    fy: 1081,
    r: 0.6,
    gradientTransform: "translate(-1922.8 1009930.12) scale(1921.98 -933.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#589866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5c975d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#589866",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 874.21,
    width: 1920,
    height: 208.07,
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 1.5,
    cy: 1080.5,
    fx: 1.5,
    fy: 1080.5,
    r: 0.5,
    gradientTransform: "translate(333.56 329125.28) scale(470 -304)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 1.5,
    cy: 1080.45,
    fx: 1.5,
    fy: 1080.45,
    r: 0.63,
    gradientTransform: "translate(-1816090.4 -1034.68) rotate(90) scale(1082.28 -1681.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b2a53",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0b2a53",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0b2a53",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0b2a53",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0b2a53",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0b2a53",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b2a53"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67133",
    "data-name": "Group 67133"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    x: 0,
    width: 1921.98,
    height: 593.81,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    x: 0,
    y: 573.9,
    width: 1921.98,
    height: 506.1,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44787",
    "data-name": "Group 44787"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886",
    "data-name": "Rectangle 886",
    x: 812.08,
    y: 328.86,
    width: 136.02,
    height: 286.11,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889",
    "data-name": "Rectangle 889",
    x: 896.05,
    y: 463.32,
    width: 192.58,
    height: 151.65,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887",
    "data-name": "Rectangle 887",
    x: 742.97,
    y: 454.49,
    width: 152.68,
    height: 160.48,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    x: 489.13,
    y: 436.26,
    width: 152.68,
    height: 178.7,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    x: 624.72,
    y: 375.54,
    width: 137.06,
    height: 239.42,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890",
    "data-name": "Rectangle 890",
    x: 412.61,
    y: 344.31,
    width: 135.33,
    height: 270.65,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891",
    "data-name": "Rectangle 891",
    x: 254.44,
    y: 413.71,
    width: 201.26,
    height: 201.26,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    x: 0,
    y: 513.19,
    width: 272.96,
    height: 101.77,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_990",
    "data-name": "Rectangle 990",
    x: 480.33,
    y: 330.43,
    width: 45.11,
    height: 27.76,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    x: 887.13,
    y: 312.44,
    width: 37.52,
    height: 60.97,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    x: 642.06,
    y: 358.19,
    width: 100.63,
    height: 45.11,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993",
    "data-name": "Rectangle 993",
    x: 273.49,
    y: 396.36,
    width: 72.87,
    height: 50.31,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1027",
    "data-name": "Rectangle 1027",
    x: 81.83,
    y: 447.6,
    width: 109.3,
    height: 110.53,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12917",
    "data-name": "Rectangle 12917",
    x: 108.13,
    y: 433.89,
    width: 57.25,
    height: 46.84,
    fill: "#33acc2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44788",
    "data-name": "Group 44788"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886-2",
    "data-name": "Rectangle 886-2",
    x: 1583.96,
    y: 452.02,
    width: 100.63,
    height: 162.16,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889-2",
    "data-name": "Rectangle 889-2",
    x: 1632.54,
    y: 523.88,
    width: 289.44,
    height: 90.3,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887-2",
    "data-name": "Rectangle 887-2",
    x: 1479.87,
    y: 494.47,
    width: 152.68,
    height: 119.71,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893-2",
    "data-name": "Rectangle 893-2",
    x: 1226.56,
    y: 435.48,
    width: 152.68,
    height: 178.7,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888-2",
    "data-name": "Rectangle 888-2",
    x: 1361.89,
    y: 374.76,
    width: 137.06,
    height: 239.42,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890-2",
    "data-name": "Rectangle 890-2",
    x: 1150.22,
    y: 343.53,
    width: 135.33,
    height: 270.65,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891-2",
    "data-name": "Rectangle 891-2",
    x: 992.34,
    y: 412.92,
    width: 201.26,
    height: 201.26,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_990-2",
    "data-name": "Rectangle 990-2",
    x: 1217.89,
    y: 329.65,
    width: 45.11,
    height: 27.76,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991-2",
    "data-name": "Rectangle 991-2",
    x: 1639.48,
    y: 439.88,
    width: 27.76,
    height: 45.11,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886-2-2",
    "data-name": "Rectangle 886-2-2",
    x: 1760.33,
    y: 470.38,
    width: 100.63,
    height: 143.8,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991-2-2",
    "data-name": "Rectangle 991-2-2",
    x: 1782.53,
    y: 458.18,
    width: 41.65,
    height: 45.11,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992-2",
    "data-name": "Rectangle 992-2",
    x: 1379.24,
    y: 357.41,
    width: 100.63,
    height: 45.11,
    fill: "#33acc2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993-2",
    "data-name": "Rectangle 993-2",
    x: 1011.43,
    y: 395.58,
    width: 72.87,
    height: 50.31,
    fill: "#33acc2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67131",
    "data-name": "Group 67131"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    x: 105.13,
    y: 463.38,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    x: 275.51,
    y: 435.98,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    x: 275.51,
    y: 467.13,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    x: 351.5,
    y: 468.37,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    x: 444.96,
    y: 361.06,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    x: 444.96,
    y: 392.21,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    x: 841.02,
    y: 361.06,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    x: 841.02,
    y: 392.21,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    x: 661.56,
    y: 398.09,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    x: 661.56,
    y: 429.24,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67132",
    "data-name": "Group 67132"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    x: 1793.39,
    y: 560.1,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    x: 1641.07,
    y: 470.38,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    x: 1641.07,
    y: 501.53,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    x: 1255.1,
    y: 367.98,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    x: 1462.8,
    y: 392.21,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    x: 1462.8,
    y: 423.37,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    x: 1024.24,
    y: 438.83,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    x: 1049.05,
    y: 438.83,
    width: 9.97,
    height: 14.12,
    fill: "#4fcadb"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18458",
    "data-name": "Rectangle 18458",
    x: 0,
    y: 639.59,
    width: 1921.98,
    height: 440.41,
    fill: "url(#radial-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_67134",
    "data-name": "Group 67134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67266",
    "data-name": "Group 67266"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18688",
    "data-name": "Rectangle 18688",
    x: 0,
    y: 557.03,
    width: 1920,
    height: 84.2,
    fill: "#298aab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19131",
    "data-name": "Rectangle 19131",
    x: 232.26,
    y: 497.76,
    width: 198.91,
    height: 67.68,
    fill: "#298aab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19132",
    "data-name": "Rectangle 19132",
    x: 465.96,
    y: 466.37,
    width: 216.53,
    height: 99.08,
    fill: "#298aab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19133",
    "data-name": "Rectangle 19133",
    x: 1196.97,
    y: 466.37,
    width: 216.53,
    height: 99.08,
    fill: "#298aab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19134",
    "data-name": "Rectangle 19134",
    x: 1571.84,
    y: 509.71,
    width: 170.81,
    height: 55.74,
    fill: "#298aab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19135",
    "data-name": "Rectangle 19135",
    x: 1648.05,
    y: 497.58,
    width: 64.79,
    height: 23.23,
    fill: "#298aab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19136",
    "data-name": "Rectangle 19136",
    x: 273.53,
    y: 481.68,
    width: 76.3,
    height: 28.13,
    fill: "#298aab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19137",
    "data-name": "Rectangle 19137",
    x: 595.54,
    y: 449.32,
    width: 52.56,
    height: 29.34,
    fill: "#298aab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19138",
    "data-name": "Rectangle 19138",
    x: 1791.41,
    y: 503.79,
    width: 101.1,
    height: 73.12,
    fill: "#298aab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19139",
    "data-name": "Rectangle 19139",
    x: 27.11,
    y: 495.75,
    width: 146.08,
    height: 92.93,
    fill: "#298aab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_134628",
    "data-name": "Path 134628",
    d: "M0,606.82v83.31l221.03,25.21,97.27-72.47H1541.37v3.26l378.63,40.34v-79.64H0Z",
    fill: "#000051",
    isolation: "isolate",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67267",
    "data-name": "Group 67267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315-2",
    "data-name": "Path 315-2",
    d: "M1504.82,628.76c9.16,28.08,116.9,28.43,122.83,24.12,36.55,3.38,85.1-5.5,82.56-12.06,8.36-5.2,11.14-15.08,6.5-23.16-4.1-9.6-13.72-14.79-21.44-11.59l-.9,.23c-.02-2.77-.46-5.52-1.33-8.15-5.24-13.76-18.51-21.87-29.72-18.17-3.35,.87-6.41,2.6-8.88,5.02-7.34-13.77-21.43-20.98-33.3-17.03-6.97,1.76-12.78,6.56-15.83,13.07-9.38-17.88-32.62-26.36-53.43-19.51-30.77,7.93-56.23,39.16-47.07,67.24Z",
    fill: "#336545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134629",
    "data-name": "Path 134629",
    d: "M1627.65,652.88c24.55,2.27,54.51-.99,70.77-5.36,.79-3.57,.21-7.31-1.62-10.47-3.65-8.54-12.21-13.16-19.07-10.31l-.8,.2c-.01-2.46-.41-4.91-1.18-7.25-4.66-12.24-16.47-19.46-26.44-16.17-2.98,.77-5.7,2.31-7.9,4.46-6.53-12.25-19.06-18.66-29.62-15.15-6.2,1.57-11.37,5.84-14.08,11.63-8.34-15.9-29.02-23.45-47.53-17.36-22.2,5.72-41.29,25.07-43.37,45.5,17.28,24.26,115.21,24.39,120.86,20.28Z",
    fill: "#336545"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_316-2",
    "data-name": "Path 316-2",
    d: "M334.44,664.03c1.3-1.95,2.01-4.22,2.07-6.56,0-8.89-10.68-16.83-27.37-22.05,3.7-4.24,5.79-9.64,5.9-15.27-1.88-18.66-22.71-32.66-46.72-31.4-21.95-.92-41.53,10.64-46.29,27.33-5.66-1.9-11.59-2.85-17.55-2.81-20.72-.86-38.45,11.44-39.7,27.55,.03,3.15,.8,6.24,2.24,9.04h-1.6c-2.01-.18-4.02-.18-6.03,0-14.56,1.6-24.7,12.08-22.63,23.41h0c1.98,10.89,14.57,18.68,28.66,17.73,5.57,1.44,11.33,2.08,17.08,1.89,27.7,1.94,55.52,.9,83-3.09,55.86-4.33,100.45-13.18,99.62-19.65-.46-3.23-12.14-5.28-30.68-6.11Z",
    fill: "#336545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320-2-2",
    "data-name": "Path 320-2-2",
    d: "M1218.58,663.52l52.6,11.67,.72-174.7-49.68,18.96-3.64,144.07Z",
    fill: "#7f503b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1317.85,682.75l357.07-10.15-78.55-30.25h-339.78l61.25,40.4Z",
    fill: "#75a0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1674.93,672.6v6.27l-286.7,13.03-70.37-9.15,357.07-10.15Z",
    fill: "#537d86"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319-2-2",
    "data-name": "Path 319-2-2",
    d: "M1265.8,664.41l.04-141.04,342.85,.62,2.75,131.73-345.64,8.7Z",
    fill: "#d7dfe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M1266.01,497.06l341.98,.19,.7,26.73-342.84,1.32,.16-28.25Z",
    fill: "#c77239"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67270",
    "data-name": "Group 67270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67268",
    "data-name": "Group 67268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2",
    "data-name": "Path 328-2-5-2",
    d: "M1321.6,572.64h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-2",
    "data-name": "Path 328-2-5-2-2",
    d: "M1349.15,572.64h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-3",
    "data-name": "Path 328-2-5-2-3",
    d: "M1376.7,572.64h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-4",
    "data-name": "Path 328-2-5-2-4",
    d: "M1404.25,572.64h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-5",
    "data-name": "Path 328-2-5-2-5",
    d: "M1431.8,572.64h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-6",
    "data-name": "Path 328-2-5-2-6",
    d: "M1459.35,572.64h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-7",
    "data-name": "Path 328-2-5-2-7",
    d: "M1486.9,572.64h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-8",
    "data-name": "Path 328-2-5-2-8",
    d: "M1514.45,572.64h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-9",
    "data-name": "Path 328-2-5-2-9",
    d: "M1542,572.64h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-10",
    "data-name": "Path 328-2-5-2-10",
    d: "M1569.55,572.64h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-11",
    "data-name": "Path 328-2-5-2-11",
    d: "M1321.6,627.42h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-12",
    "data-name": "Path 328-2-5-2-12",
    d: "M1349.15,627.42h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-13",
    "data-name": "Path 328-2-5-2-13",
    d: "M1376.7,627.42h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-14",
    "data-name": "Path 328-2-5-2-14",
    d: "M1404.25,627.42h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-15",
    "data-name": "Path 328-2-5-2-15",
    d: "M1431.8,627.42h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-16",
    "data-name": "Path 328-2-5-2-16",
    d: "M1459.35,627.42h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-17",
    "data-name": "Path 328-2-5-2-17",
    d: "M1486.9,627.42h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-18",
    "data-name": "Path 328-2-5-2-18",
    d: "M1514.45,627.42h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-19",
    "data-name": "Path 328-2-5-2-19",
    d: "M1542,627.42h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-20",
    "data-name": "Path 328-2-5-2-20",
    d: "M1569.55,627.42h19.91v-31.37h-19.91v31.37Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2",
    "data-name": "Path 321-2-5-2",
    d: "M1325.14,575.29h19.19l-2.82-2.65h-19.92l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134630",
    "data-name": "Path 134630",
    d: "M1341.52,541.27h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19140",
    "data-name": "Rectangle 19140",
    x: 1321.61,
    y: 541.27,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-2",
    "data-name": "Path 321-2-5-2-2",
    d: "M1352.69,575.29h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134631",
    "data-name": "Path 134631",
    d: "M1369.07,541.27h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19141",
    "data-name": "Rectangle 19141",
    x: 1349.15,
    y: 541.27,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-3",
    "data-name": "Path 321-2-5-2-3",
    d: "M1380.24,575.29h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134632",
    "data-name": "Path 134632",
    d: "M1396.61,541.27h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19142",
    "data-name": "Rectangle 19142",
    x: 1376.7,
    y: 541.27,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-4",
    "data-name": "Path 321-2-5-2-4",
    d: "M1407.79,575.29h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134633",
    "data-name": "Path 134633",
    d: "M1424.16,541.27h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19143",
    "data-name": "Rectangle 19143",
    x: 1404.25,
    y: 541.27,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-5",
    "data-name": "Path 321-2-5-2-5",
    d: "M1435.34,575.29h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134634",
    "data-name": "Path 134634",
    d: "M1451.71,541.27h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19144",
    "data-name": "Rectangle 19144",
    x: 1431.8,
    y: 541.27,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-6",
    "data-name": "Path 321-2-5-2-6",
    d: "M1462.89,575.29h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134635",
    "data-name": "Path 134635",
    d: "M1479.26,541.27h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19145",
    "data-name": "Rectangle 19145",
    x: 1459.35,
    y: 541.27,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-7",
    "data-name": "Path 321-2-5-2-7",
    d: "M1490.44,575.29h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134636",
    "data-name": "Path 134636",
    d: "M1506.81,541.27h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19146",
    "data-name": "Rectangle 19146",
    x: 1486.9,
    y: 541.27,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-8",
    "data-name": "Path 321-2-5-2-8",
    d: "M1517.99,575.29h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134637",
    "data-name": "Path 134637",
    d: "M1534.36,541.27h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19147",
    "data-name": "Rectangle 19147",
    x: 1514.45,
    y: 541.27,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-9",
    "data-name": "Path 321-2-5-2-9",
    d: "M1545.54,575.29h19.19l-2.82-2.65h-19.91l3.53,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134638",
    "data-name": "Path 134638",
    d: "M1561.91,541.27h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19148",
    "data-name": "Rectangle 19148",
    x: 1542,
    y: 541.27,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-10",
    "data-name": "Path 321-2-5-2-10",
    d: "M1573.08,575.29h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134639",
    "data-name": "Path 134639",
    d: "M1589.46,541.27h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19149",
    "data-name": "Rectangle 19149",
    x: 1569.55,
    y: 541.27,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-11",
    "data-name": "Path 321-2-5-2-11",
    d: "M1325.14,630.07h19.19l-2.82-2.65h-19.92l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134640",
    "data-name": "Path 134640",
    d: "M1341.52,596.05h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19150",
    "data-name": "Rectangle 19150",
    x: 1321.61,
    y: 596.05,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-12",
    "data-name": "Path 321-2-5-2-12",
    d: "M1352.69,630.07h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134641",
    "data-name": "Path 134641",
    d: "M1369.07,596.05h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19151",
    "data-name": "Rectangle 19151",
    x: 1349.15,
    y: 596.05,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-13",
    "data-name": "Path 321-2-5-2-13",
    d: "M1380.24,630.07h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134642",
    "data-name": "Path 134642",
    d: "M1396.61,596.05h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19152",
    "data-name": "Rectangle 19152",
    x: 1376.7,
    y: 596.05,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-14",
    "data-name": "Path 321-2-5-2-14",
    d: "M1407.79,630.07h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134643",
    "data-name": "Path 134643",
    d: "M1424.16,596.05h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19153",
    "data-name": "Rectangle 19153",
    x: 1404.25,
    y: 596.05,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-15",
    "data-name": "Path 321-2-5-2-15",
    d: "M1435.34,630.07h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134644",
    "data-name": "Path 134644",
    d: "M1451.71,596.05h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19154",
    "data-name": "Rectangle 19154",
    x: 1431.8,
    y: 596.05,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-16",
    "data-name": "Path 321-2-5-2-16",
    d: "M1462.89,630.07h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134645",
    "data-name": "Path 134645",
    d: "M1479.26,596.05h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19155",
    "data-name": "Rectangle 19155",
    x: 1459.35,
    y: 596.05,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-17",
    "data-name": "Path 321-2-5-2-17",
    d: "M1490.44,630.07h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134646",
    "data-name": "Path 134646",
    d: "M1506.81,596.05h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19156",
    "data-name": "Rectangle 19156",
    x: 1486.9,
    y: 596.05,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-18",
    "data-name": "Path 321-2-5-2-18",
    d: "M1517.99,630.07h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134647",
    "data-name": "Path 134647",
    d: "M1534.36,596.05h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19157",
    "data-name": "Rectangle 19157",
    x: 1514.45,
    y: 596.05,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-19",
    "data-name": "Path 321-2-5-2-19",
    d: "M1545.54,630.07h19.19l-2.82-2.65h-19.91l3.53,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134648",
    "data-name": "Path 134648",
    d: "M1561.91,596.05h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19158",
    "data-name": "Rectangle 19158",
    x: 1542,
    y: 596.05,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-20",
    "data-name": "Path 321-2-5-2-20",
    d: "M1573.08,630.07h19.19l-2.82-2.65h-19.91l3.54,2.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134649",
    "data-name": "Path 134649",
    d: "M1589.46,596.05h2.87v33.97l-2.87-2.65v-31.32Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19159",
    "data-name": "Rectangle 19159",
    x: 1569.55,
    y: 596.05,
    width: 19.91,
    height: 2.28,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67269",
    "data-name": "Group 67269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134650",
    "data-name": "Path 134650",
    d: "M1321.6,612.06v15.35h19.91v-14.86c-6.63-.2-13.27-.38-19.91-.49Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134651",
    "data-name": "Path 134651",
    d: "M1349.15,612.79v14.63h19.91v-14.04c-6.64-.17-13.28-.38-19.91-.59Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134652",
    "data-name": "Path 134652",
    d: "M1365.92,558.03c-5.59-.05-11.18-.15-16.76-.25v14.85h19.91v-14.59c-1.05,0-2.1,0-3.15-.02Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134653",
    "data-name": "Path 134653",
    d: "M1321.6,557.52v15.12h19.91v-14.98c-6.63-.1-13.27-.17-19.91-.15Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134654",
    "data-name": "Path 134654",
    d: "M1376.7,613.55v13.87h19.91v-13.72c-6.63,.03-13.27-.01-19.91-.15Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134655",
    "data-name": "Path 134655",
    d: "M1548.51,557.51c-2.17,.18-4.34,.36-6.52,.55v14.58h19.91v-16.14c-4.47,.3-8.94,.65-13.4,1.02Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134656",
    "data-name": "Path 134656",
    d: "M1524.6,612.6c-3.38-.24-6.76-.45-10.15-.64v15.45h19.91v-14.03c-3.26-.28-6.51-.55-9.76-.79Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134657",
    "data-name": "Path 134657",
    d: "M1518.56,559.4c-1.37,.01-2.74,.02-4.11,.01v13.22h19.91v-13.97c-5.26,.39-10.52,.68-15.8,.74Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134658",
    "data-name": "Path 134658",
    d: "M1488.4,558.4c-.5-.03-1-.07-1.5-.1v14.34h19.91v-13.35c-6.14-.17-12.28-.5-18.41-.89Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134659",
    "data-name": "Path 134659",
    d: "M1493.76,611.09c-2.29-.06-4.57-.11-6.86-.14v16.47h19.91v-15.84c-4.35-.2-8.7-.36-13.05-.48Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134660",
    "data-name": "Path 134660",
    d: "M1376.7,558.06v14.58h19.91v-15c-6.63,.3-13.27,.41-19.91,.42Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134661",
    "data-name": "Path 134661",
    d: "M1555.09,614.68c-4.38-.08-8.74-.34-13.09-.67v13.41h19.91v-12.7c-2.27,.01-4.55,0-6.82-.04Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134662",
    "data-name": "Path 134662",
    d: "M1569.55,614.61v12.8h19.91v-13.2c-6.64,.06-13.28,.27-19.91,.4Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134663",
    "data-name": "Path 134663",
    d: "M1569.55,556.04v16.6h19.91v-17.01c-6.63-.11-13.28,.07-19.91,.41Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134664",
    "data-name": "Path 134664",
    d: "M1404.25,557.19v15.45h19.91v-16.85c-6.65,.3-13.27,.92-19.91,1.4Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134665",
    "data-name": "Path 134665",
    d: "M1404.25,613.61v13.8h19.91v-14.49c-6.64,.36-13.27,.58-19.91,.69Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134666",
    "data-name": "Path 134666",
    d: "M1431.8,612.44v14.97h19.91v-16.06c-6.64,.26-13.28,.62-19.91,1.09Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134667",
    "data-name": "Path 134667",
    d: "M1459.35,556.43v16.21h19.91v-14.86c-6.64-.46-13.27-.95-19.91-1.35Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134668",
    "data-name": "Path 134668",
    d: "M1431.8,555.59v17.05h19.91v-16.62c-6.63-.31-13.27-.49-19.91-.43Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134669",
    "data-name": "Path 134669",
    d: "M1459.35,611.1v16.31h19.91v-16.55c-6.64-.03-13.28,.05-19.91,.23Z",
    fill: "#4f828e"
  }))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1194",
    "data-name": "Line 1194",
    x1: 1301.49,
    y1: 504.94,
    x2: 1608.12,
    y2: 505.3,
    fill: "none",
    stroke: "#a15f39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67271",
    "data-name": "Group 67271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315-2-2",
    "data-name": "Path 315-2-2",
    d: "M1229.89,656.68c0,21.23-.16,38.44,32.86,38.44,7.89,0,14.68,12.69,21.94,10.74,35.03,8.93,113.92,5,117.35,3.84s27.28-2.63,26.89-7.67c9.94-2.12,15.86-8.52,13.9-14.98-.96-7.43-8.79-12.78-17.44-11.94h-.96c.86-1.86,1.3-3.88,1.31-5.92-.74-10.54-11.23-18.59-23.51-18.02-3.55,0-7.07,.64-10.39,1.91-2.81-10.92-14.4-18.49-27.4-17.87-7.8,.09-15.1,2.39-19.86,6.27-3.5-14.16-23.72-24.26-46.49-23.22-32.97,0-68.2,17.21-68.2,38.44Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134670",
    "data-name": "Path 134670",
    d: "M1402.04,709.69c.77-.22,1.56-.38,2.36-.49,.97-1.95,1.17-4.19,.53-6.27-.96-7.44-8.79-12.79-17.44-11.94h-.96c.86-1.86,1.31-3.88,1.31-5.92-.74-10.54-11.24-18.59-23.51-18.02-3.55,0-7.07,.64-10.39,1.9-2.81-10.92-14.4-18.49-27.4-17.87-7.8,.09-15.1,2.39-19.86,6.27-3.5-14.16-23.72-24.26-46.49-23.22-6.09,.01-12.17,.57-18.17,1.67-7.48,6.01-12.14,13.18-12.14,20.89,0,21.23-.16,38.44,32.86,38.44,7.89,0,14.68,12.69,21.94,10.74,35.02,8.93,113.91,5.01,117.35,3.84Z",
    fill: "#336545"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_335-2",
    "data-name": "Path 335-2",
    d: "M1300.22,673.82l-1067.34,23.79,145.73,58.04,1078.34-30.97-156.73-50.86Z",
    fill: "#75a0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M378.61,755.65l1078.33-30.97v8.81l-1074.33,29.38-149.73-65.19,145.73,57.97Z",
    fill: "#537d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134671",
    "data-name": "Path 134671",
    d: "M1069.18,704.24c4.7,0,227.77,98.92,227.77,98.92l-325.79,48,169.46,124.25h-262.81s-140.41-157.33-136.88-158.71,339.18-43.63,339.18-43.63l-102.48-67.46,91.55-1.37Z",
    fill: "#75a0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134672",
    "data-name": "Path 134672",
    d: "M1010.39,975.28l-153.58-147.47,306.13-41.46-147.3-90.76,161.89,94.13-308.77,43.54,152,142.03h-10.37Z",
    fill: "#537d86"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67319",
    "data-name": "Group 67319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M977.62,491.24l-144.82,3.5v-130.48h144.82v126.98Z",
    fill: "#5f778e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M779.86,389.89l52.94-25.58v130.43l-51.47,1.85-1.48-106.7Z",
    fill: "#465a67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319-2",
    "data-name": "Path 319-2",
    d: "M744.87,705.85l1.14-267.04,553.86,3.42,3.44,247.17-558.44,16.46Z",
    fill: "#e7f0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320-2",
    "data-name": "Path 320-2",
    d: "M662.33,687.51l82.55,18.32,1.14-280.49-77.97,29.76-5.72,232.41Z",
    fill: "#7c4d3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M746.02,425.36l553.86,3.41,1.02,60.97-555.53-.7,.65-63.67Z",
    fill: "#c77239"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1195",
    "data-name": "Line 1195",
    x1: 746.02,
    y1: 433.92,
    x2: 1299.88,
    y2: 436.48,
    fill: "none",
    stroke: "#a15f39",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67318",
    "data-name": "Group 67318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67314",
    "data-name": "Group 67314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67274",
    "data-name": "Group 67274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67272",
    "data-name": "Group 67272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-21",
    "data-name": "Path 328-2-5-2-21",
    d: "M765.87,675.66h44.71v-94.32h-44.71v94.32Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-21",
    "data-name": "Path 321-2-5-2-21",
    d: "M773.82,681.62h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134673",
    "data-name": "Path 134673",
    d: "M810.59,581.34h6.45v100.18l-6.45-5.96v-94.22Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19160",
    "data-name": "Rectangle 19160",
    x: 765.87,
    y: 581.34,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67273",
    "data-name": "Group 67273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134674",
    "data-name": "Path 134674",
    d: "M765.87,641.7v33.96h44.71v-33.63c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67277",
    "data-name": "Group 67277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67275",
    "data-name": "Group 67275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-22",
    "data-name": "Path 328-2-5-2-22",
    d: "M765.87,559.12h44.71v-38.09h-44.71v38.09Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-22",
    "data-name": "Path 321-2-5-2-22",
    d: "M773.82,565.08h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134675",
    "data-name": "Path 134675",
    d: "M810.59,521.03h6.45v43.95l-6.45-5.96v-37.99Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19161",
    "data-name": "Rectangle 19161",
    x: 765.87,
    y: 521.03,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67276",
    "data-name": "Group 67276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134676",
    "data-name": "Path 134676",
    d: "M765.87,543.09v16.03h44.71v-15.71c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67280",
    "data-name": "Group 67280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67278",
    "data-name": "Group 67278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-23",
    "data-name": "Path 328-2-5-2-23",
    d: "M830.26,559.12h44.71v-38.09h-44.71v38.09Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-23",
    "data-name": "Path 321-2-5-2-23",
    d: "M838.2,565.08h43.1l-6.33-5.95h-44.71l7.95,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134677",
    "data-name": "Path 134677",
    d: "M874.97,521.03h6.45v43.95l-6.45-5.96v-37.99Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19162",
    "data-name": "Rectangle 19162",
    x: 830.26,
    y: 521.03,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67279",
    "data-name": "Group 67279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134678",
    "data-name": "Path 134678",
    d: "M830.26,543.09v16.03h44.71v-15.71c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67283",
    "data-name": "Group 67283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67281",
    "data-name": "Group 67281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-24",
    "data-name": "Path 328-2-5-2-24",
    d: "M890.56,559.12h44.71v-38.09h-44.71v38.09Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-24",
    "data-name": "Path 321-2-5-2-24",
    d: "M898.5,565.08h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134679",
    "data-name": "Path 134679",
    d: "M935.27,521.03h6.45v43.95l-6.45-5.96v-37.99Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19163",
    "data-name": "Rectangle 19163",
    x: 890.56,
    y: 521.03,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67282",
    "data-name": "Group 67282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134680",
    "data-name": "Path 134680",
    d: "M890.56,543.09v16.03h44.71v-15.71c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67286",
    "data-name": "Group 67286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67284",
    "data-name": "Group 67284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-25",
    "data-name": "Path 328-2-5-2-25",
    d: "M962.47,573.93h52.11v-52.9h-52.11v52.9Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-25",
    "data-name": "Path 321-2-5-2-25",
    d: "M970.42,579.88h50.5l-6.33-5.95h-52.11l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134681",
    "data-name": "Path 134681",
    d: "M1014.59,521.03h6.45v58.75l-6.45-5.96v-52.79Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19164",
    "data-name": "Rectangle 19164",
    x: 962.47,
    y: 521.03,
    width: 52.12,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67285",
    "data-name": "Group 67285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134682",
    "data-name": "Path 134682",
    d: "M962.47,552.61v21.32h52.11v-20.99c-14.9-.23-37.21-.38-52.11-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67289",
    "data-name": "Group 67289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67287",
    "data-name": "Group 67287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-26",
    "data-name": "Path 328-2-5-2-26",
    d: "M1031.85,573.93h52.11v-52.9h-52.11v52.9Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-26",
    "data-name": "Path 321-2-5-2-26",
    d: "M1039.79,579.88h50.5l-6.33-5.95h-52.11l7.95,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134683",
    "data-name": "Path 134683",
    d: "M1083.96,521.03h6.45v58.75l-6.45-5.96v-52.79Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19165",
    "data-name": "Rectangle 19165",
    x: 1031.85,
    y: 521.03,
    width: 52.12,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67288",
    "data-name": "Group 67288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134684",
    "data-name": "Path 134684",
    d: "M1031.85,552.61v21.32h52.11v-20.99c-14.9-.23-37.21-.38-52.11-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67292",
    "data-name": "Group 67292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67290",
    "data-name": "Group 67290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-27",
    "data-name": "Path 328-2-5-2-27",
    d: "M830.66,675.66h44.71v-94.32h-44.71v94.32Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-27",
    "data-name": "Path 321-2-5-2-27",
    d: "M838.61,681.62h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134685",
    "data-name": "Path 134685",
    d: "M875.37,581.34h6.45v100.18l-6.45-5.96v-94.22Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19166",
    "data-name": "Rectangle 19166",
    x: 830.66,
    y: 581.34,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67291",
    "data-name": "Group 67291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134686",
    "data-name": "Path 134686",
    d: "M830.66,641.7v33.96h44.71v-33.63c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67295",
    "data-name": "Group 67295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67293",
    "data-name": "Group 67293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-28",
    "data-name": "Path 328-2-5-2-28",
    d: "M893.41,675.66h44.71v-94.32h-44.71v94.32Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-28",
    "data-name": "Path 321-2-5-2-28",
    d: "M901.36,681.62h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134687",
    "data-name": "Path 134687",
    d: "M938.13,581.34h6.45v100.18l-6.45-5.96v-94.22Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19167",
    "data-name": "Rectangle 19167",
    x: 893.41,
    y: 581.34,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67294",
    "data-name": "Group 67294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134688",
    "data-name": "Path 134688",
    d: "M893.41,641.7v33.96h44.71v-33.63c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67298",
    "data-name": "Group 67298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67296",
    "data-name": "Group 67296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-29",
    "data-name": "Path 328-2-5-2-29",
    d: "M1107.13,675.66h44.71v-94.32h-44.71v94.32Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-29",
    "data-name": "Path 321-2-5-2-29",
    d: "M1115.07,681.62h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134689",
    "data-name": "Path 134689",
    d: "M1151.84,581.34h6.45v100.18l-6.45-5.96v-94.22Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19168",
    "data-name": "Rectangle 19168",
    x: 1107.13,
    y: 581.34,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67297",
    "data-name": "Group 67297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134690",
    "data-name": "Path 134690",
    d: "M1107.13,641.7v33.96h44.71v-33.63c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67301",
    "data-name": "Group 67301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67299",
    "data-name": "Group 67299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-30",
    "data-name": "Path 328-2-5-2-30",
    d: "M1107.13,559.12h44.71v-38.09h-44.71v38.09Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-30",
    "data-name": "Path 321-2-5-2-30",
    d: "M1115.07,565.08h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134691",
    "data-name": "Path 134691",
    d: "M1151.84,521.03h6.45v43.95l-6.45-5.96v-37.99Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19169",
    "data-name": "Rectangle 19169",
    x: 1107.13,
    y: 521.03,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67300",
    "data-name": "Group 67300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134692",
    "data-name": "Path 134692",
    d: "M1107.13,543.09v16.03h44.71v-15.71c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67304",
    "data-name": "Group 67304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67302",
    "data-name": "Group 67302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-31",
    "data-name": "Path 328-2-5-2-31",
    d: "M1171.51,559.12h44.71v-38.09h-44.71v38.09Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-31",
    "data-name": "Path 321-2-5-2-31",
    d: "M1179.45,565.08h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134693",
    "data-name": "Path 134693",
    d: "M1216.22,521.03h6.45v43.95l-6.45-5.96v-37.99Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19170",
    "data-name": "Rectangle 19170",
    x: 1171.51,
    y: 521.03,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67303",
    "data-name": "Group 67303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134694",
    "data-name": "Path 134694",
    d: "M1171.51,543.09v16.03h44.71v-15.71c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67307",
    "data-name": "Group 67307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67305",
    "data-name": "Group 67305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-32",
    "data-name": "Path 328-2-5-2-32",
    d: "M1231.81,559.12h44.71v-38.09h-44.71v38.09Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-32",
    "data-name": "Path 321-2-5-2-32",
    d: "M1239.76,565.08h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134695",
    "data-name": "Path 134695",
    d: "M1276.53,521.03h6.45v43.95l-6.45-5.96v-37.99Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19171",
    "data-name": "Rectangle 19171",
    x: 1231.81,
    y: 521.03,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67306",
    "data-name": "Group 67306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134696",
    "data-name": "Path 134696",
    d: "M1231.81,543.09v16.03h44.71v-15.71c-14.91-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67310",
    "data-name": "Group 67310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67308",
    "data-name": "Group 67308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-33",
    "data-name": "Path 328-2-5-2-33",
    d: "M1171.91,675.66h44.71v-94.32h-44.71v94.32Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-33",
    "data-name": "Path 321-2-5-2-33",
    d: "M1179.86,681.62h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134697",
    "data-name": "Path 134697",
    d: "M1216.63,581.34h6.45v100.18l-6.45-5.96v-94.22Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19172",
    "data-name": "Rectangle 19172",
    x: 1171.91,
    y: 581.34,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67309",
    "data-name": "Group 67309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134698",
    "data-name": "Path 134698",
    d: "M1171.91,641.7v33.96h44.71v-33.63c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67313",
    "data-name": "Group 67313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67311",
    "data-name": "Group 67311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-34",
    "data-name": "Path 328-2-5-2-34",
    d: "M1234.67,675.66h44.71v-94.32h-44.71v94.32Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-34",
    "data-name": "Path 321-2-5-2-34",
    d: "M1242.61,681.62h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134699",
    "data-name": "Path 134699",
    d: "M1279.38,581.34h6.45v100.18l-6.45-5.96v-94.22Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19173",
    "data-name": "Rectangle 19173",
    x: 1234.67,
    y: 581.34,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67312",
    "data-name": "Group 67312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134700",
    "data-name": "Path 134700",
    d: "M1234.67,641.7v33.96h44.71v-33.63c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67315",
    "data-name": "Group 67315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M1089.5,696.76l-126.45,3.08,1.77-112.15h126.45l-1.77,109.07Z",
    fill: "#5f778e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M1077.38,692.99l-107.2,2.85v-81.55l107.2-.34v79.03Z",
    fill: "#93bec9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134701",
    "data-name": "Path 134701",
    d: "M1084.82,587.69h6.45l-1.77,109.07-4.68-3.51v-105.56Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134702",
    "data-name": "Path 134702",
    d: "M1069.6,692.97l-43.6,1.24v-69.29h43.6v68.05Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134703",
    "data-name": "Path 134703",
    d: "M1023.97,693.38l-43.6,1.65v-69.7h43.6v68.05Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134704",
    "data-name": "Path 134704",
    d: "M1023.22,657.74c-14.29-.34-28.57-.84-42.86-1.2v38.49l43.6-1.65v-35.63l-.74-.02Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134705",
    "data-name": "Path 134705",
    d: "M1059.25,657.77c-5.85,.45-11.72,.35-17.58,.29-5.22-.05-10.44-.14-15.67-.27v36.41l43.6-1.24v-36.37c-3.44,.49-6.89,.91-10.36,1.17Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134706",
    "data-name": "Path 134706",
    d: "M1084.82,693.25l-121.94,2.59,.16,4,126.45-3.08-4.68-3.51Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134707",
    "data-name": "Path 134707",
    d: "M1084.69,595.19l.12-7.5h-120l-.12,7.5h120Z",
    fill: "#506475"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67316",
    "data-name": "Group 67316"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19174",
    "data-name": "Rectangle 19174",
    x: 761.79,
    y: 505.55,
    width: 177.86,
    height: 6.72,
    fill: "#719196"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19175",
    "data-name": "Rectangle 19175",
    x: 761.79,
    y: 500.96,
    width: 177.86,
    height: 6.72,
    fill: "#9fbbbc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67317",
    "data-name": "Group 67317"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19176",
    "data-name": "Rectangle 19176",
    x: 1105.9,
    y: 505.55,
    width: 177.86,
    height: 6.72,
    fill: "#719196"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19177",
    "data-name": "Rectangle 19177",
    x: 1105.9,
    y: 500.96,
    width: 177.86,
    height: 6.72,
    fill: "#9fbbbc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67326",
    "data-name": "Group 67326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67320",
    "data-name": "Group 67320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241-6",
    "data-name": "Group 241-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305-3",
    "data-name": "Path 305-3",
    d: "M579.06,541.53v-112.21h-37.23v112.25c12.41,.58,24.82,.36,37.23-.04Z",
    fill: "#607c8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_241-6-2",
    "data-name": "Group 241-6-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305-3-2",
    "data-name": "Path 305-3-2",
    d: "M555.03,541.53v-112.21h-13.2v112.25c12.42,.58,.79,.36,13.2-.04Z",
    fill: "#465a67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_241-6-3",
    "data-name": "Group 241-6-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305-3-3",
    "data-name": "Path 305-3-3",
    d: "M582.77,430.39v-18.24h-45.29v18.25c15.1,.09,30.19,.06,45.29,0Z",
    fill: "#607c8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_241-6-4",
    "data-name": "Group 241-6-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305-3-4",
    "data-name": "Path 305-3-4",
    d: "M547.93,430.39v-18.24h-10.45v18.25c15.1,.09-4.65,.06,10.45,0Z",
    fill: "#465a67"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67321",
    "data-name": "Group 67321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319-2-2-2",
    "data-name": "Path 319-2-2-2",
    d: "M341.51,713.44l.86-182.72,378.46-6.23,2.28,176.73-381.6,12.22Z",
    fill: "#d7dfe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320-2-2-2",
    "data-name": "Path 320-2-2-2",
    d: "M279.56,699.7l61.95,13.74,.85-197.97-58.5,22.32-4.3,161.9Z",
    fill: "#7f503b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848-2",
    "data-name": "Path 848-2",
    d: "M342.77,515.47l378.55,2.11,.63,29.59-379.52-.43,.34-31.27Z",
    fill: "#c77239"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67322",
    "data-name": "Group 67322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134708",
    "data-name": "Path 134708",
    d: "M299.71,562.39v20.17h-22c-9.78,0-7.33,6.11-7.33,13.45v37.9h-20.78v-42.79c0-18.34,3.67-28.12,19.56-28.12s30.55-.61,30.55-.61Z",
    fill: "#679aa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842-2",
    "data-name": "Path 842-2",
    d: "M319.96,712.91l-100.76,2.43v-90.79h100.76v88.35Z",
    fill: "#5f778e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843-2",
    "data-name": "Path 843-2",
    d: "M182.36,629.01l36.84-4.42v90.75l-35.81-21.54-1.03-64.79Z",
    fill: "#465a67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67325",
    "data-name": "Group 67325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67323",
    "data-name": "Group 67323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-35",
    "data-name": "Path 328-2-5-2-35",
    d: "M360.02,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-36",
    "data-name": "Path 328-2-5-2-36",
    d: "M395.06,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-37",
    "data-name": "Path 328-2-5-2-37",
    d: "M430.11,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-38",
    "data-name": "Path 328-2-5-2-38",
    d: "M465.15,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-39",
    "data-name": "Path 328-2-5-2-39",
    d: "M500.19,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-40",
    "data-name": "Path 328-2-5-2-40",
    d: "M535.24,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-41",
    "data-name": "Path 328-2-5-2-41",
    d: "M570.28,605.5h25.32v-39.9h-25.32v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-42",
    "data-name": "Path 328-2-5-2-42",
    d: "M605.32,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-43",
    "data-name": "Path 328-2-5-2-43",
    d: "M640.36,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-44",
    "data-name": "Path 328-2-5-2-44",
    d: "M675.41,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-45",
    "data-name": "Path 328-2-5-2-45",
    d: "M360.02,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-46",
    "data-name": "Path 328-2-5-2-46",
    d: "M395.06,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-47",
    "data-name": "Path 328-2-5-2-47",
    d: "M430.11,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-48",
    "data-name": "Path 328-2-5-2-48",
    d: "M465.15,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-49",
    "data-name": "Path 328-2-5-2-49",
    d: "M500.19,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-50",
    "data-name": "Path 328-2-5-2-50",
    d: "M535.24,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-51",
    "data-name": "Path 328-2-5-2-51",
    d: "M570.28,675.17h25.32v-39.9h-25.32v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-52",
    "data-name": "Path 328-2-5-2-52",
    d: "M605.32,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-53",
    "data-name": "Path 328-2-5-2-53",
    d: "M640.36,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-54",
    "data-name": "Path 328-2-5-2-54",
    d: "M675.41,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-35",
    "data-name": "Path 321-2-5-2-35",
    d: "M364.52,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134709",
    "data-name": "Path 134709",
    d: "M385.35,565.59h3.65v43.21l-3.65-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19178",
    "data-name": "Rectangle 19178",
    x: 360.02,
    y: 565.59,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-36",
    "data-name": "Path 321-2-5-2-36",
    d: "M399.56,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134710",
    "data-name": "Path 134710",
    d: "M420.39,565.59h3.65v43.21l-3.65-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19179",
    "data-name": "Rectangle 19179",
    x: 395.06,
    y: 565.59,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-37",
    "data-name": "Path 321-2-5-2-37",
    d: "M434.61,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134711",
    "data-name": "Path 134711",
    d: "M455.43,565.59h3.65v43.21l-3.65-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19180",
    "data-name": "Rectangle 19180",
    x: 430.11,
    y: 565.59,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-38",
    "data-name": "Path 321-2-5-2-38",
    d: "M469.65,608.87h24.42l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134712",
    "data-name": "Path 134712",
    d: "M490.48,565.59h3.65v43.21l-3.65-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19181",
    "data-name": "Rectangle 19181",
    x: 465.15,
    y: 565.59,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-39",
    "data-name": "Path 321-2-5-2-39",
    d: "M504.69,608.87h24.41l-3.59-3.37h-25.32l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134713",
    "data-name": "Path 134713",
    d: "M525.52,565.59h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19182",
    "data-name": "Rectangle 19182",
    x: 500.19,
    y: 565.59,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-40",
    "data-name": "Path 321-2-5-2-40",
    d: "M539.73,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134714",
    "data-name": "Path 134714",
    d: "M560.56,565.59h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19183",
    "data-name": "Rectangle 19183",
    x: 535.24,
    y: 565.59,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-41",
    "data-name": "Path 321-2-5-2-41",
    d: "M574.78,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134715",
    "data-name": "Path 134715",
    d: "M595.61,565.59h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19184",
    "data-name": "Rectangle 19184",
    x: 570.28,
    y: 565.59,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-42",
    "data-name": "Path 321-2-5-2-42",
    d: "M609.82,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134716",
    "data-name": "Path 134716",
    d: "M630.65,565.59h3.65v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19185",
    "data-name": "Rectangle 19185",
    x: 605.32,
    y: 565.59,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-43",
    "data-name": "Path 321-2-5-2-43",
    d: "M644.86,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134717",
    "data-name": "Path 134717",
    d: "M665.69,565.59h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19186",
    "data-name": "Rectangle 19186",
    x: 640.36,
    y: 565.59,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-44",
    "data-name": "Path 321-2-5-2-44",
    d: "M679.91,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134718",
    "data-name": "Path 134718",
    d: "M700.73,565.59h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19187",
    "data-name": "Rectangle 19187",
    x: 675.41,
    y: 565.59,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-45",
    "data-name": "Path 321-2-5-2-45",
    d: "M364.52,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134719",
    "data-name": "Path 134719",
    d: "M385.35,635.27h3.65v43.21l-3.65-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19188",
    "data-name": "Rectangle 19188",
    x: 360.02,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-46",
    "data-name": "Path 321-2-5-2-46",
    d: "M399.56,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134720",
    "data-name": "Path 134720",
    d: "M420.39,635.27h3.65v43.21l-3.65-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19189",
    "data-name": "Rectangle 19189",
    x: 395.06,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-47",
    "data-name": "Path 321-2-5-2-47",
    d: "M434.61,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134721",
    "data-name": "Path 134721",
    d: "M455.43,635.27h3.65v43.21l-3.65-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19190",
    "data-name": "Rectangle 19190",
    x: 430.11,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-48",
    "data-name": "Path 321-2-5-2-48",
    d: "M469.65,678.55h24.42l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134722",
    "data-name": "Path 134722",
    d: "M490.48,635.27h3.65v43.21l-3.65-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19191",
    "data-name": "Rectangle 19191",
    x: 465.15,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-49",
    "data-name": "Path 321-2-5-2-49",
    d: "M504.69,678.55h24.41l-3.59-3.37h-25.32l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134723",
    "data-name": "Path 134723",
    d: "M525.52,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19192",
    "data-name": "Rectangle 19192",
    x: 500.19,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-50",
    "data-name": "Path 321-2-5-2-50",
    d: "M539.73,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134724",
    "data-name": "Path 134724",
    d: "M560.56,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19193",
    "data-name": "Rectangle 19193",
    x: 535.24,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-51",
    "data-name": "Path 321-2-5-2-51",
    d: "M574.78,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134725",
    "data-name": "Path 134725",
    d: "M595.61,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19194",
    "data-name": "Rectangle 19194",
    x: 570.28,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-52",
    "data-name": "Path 321-2-5-2-52",
    d: "M609.82,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134726",
    "data-name": "Path 134726",
    d: "M630.65,635.27h3.65v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19195",
    "data-name": "Rectangle 19195",
    x: 605.32,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-53",
    "data-name": "Path 321-2-5-2-53",
    d: "M644.86,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134727",
    "data-name": "Path 134727",
    d: "M665.69,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19196",
    "data-name": "Rectangle 19196",
    x: 640.36,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-54",
    "data-name": "Path 321-2-5-2-54",
    d: "M679.91,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134728",
    "data-name": "Path 134728",
    d: "M700.73,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bdb4bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19197",
    "data-name": "Rectangle 19197",
    x: 675.41,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67324",
    "data-name": "Group 67324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134729",
    "data-name": "Path 134729",
    d: "M360.02,655.64v19.53h25.33v-18.9c-8.44-.25-16.88-.48-25.33-.63Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134730",
    "data-name": "Path 134730",
    d: "M395.06,656.57v18.61h25.33v-17.86c-8.44-.22-16.88-.48-25.33-.75Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134731",
    "data-name": "Path 134731",
    d: "M416.39,586.91c-7.11-.07-14.22-.19-21.33-.31v18.9h25.33v-18.56c-1.33-.01-2.67-.01-4-.02Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134732",
    "data-name": "Path 134732",
    d: "M360.02,586.26v19.24h25.33v-19.05c-8.45-.13-16.88-.21-25.33-.18Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134733",
    "data-name": "Path 134733",
    d: "M430.11,657.53v17.64h25.33v-17.45c-8.44,.04-16.88-.02-25.33-.19Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134734",
    "data-name": "Path 134734",
    d: "M648.65,586.25c-2.77,.23-5.53,.46-8.29,.7v18.54h25.33v-20.54c-5.69,.38-11.37,.83-17.04,1.29Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134735",
    "data-name": "Path 134735",
    d: "M618.23,656.33c-4.3-.31-8.61-.58-12.91-.82v19.66h25.33v-17.84c-4.14-.35-8.28-.7-12.42-1Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134736",
    "data-name": "Path 134736",
    d: "M610.56,588.66c-1.75,.02-3.49,.02-5.24,.01v16.82h25.33v-17.77c-6.68,.49-13.38,.87-20.09,.94Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134737",
    "data-name": "Path 134737",
    d: "M572.19,587.38c-.64-.04-1.27-.08-1.91-.12v18.24h25.32v-16.98c-7.81-.22-15.61-.63-23.41-1.13Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134738",
    "data-name": "Path 134738",
    d: "M579.01,654.4c-2.91-.08-5.82-.14-8.73-.18v20.95h25.32v-20.16c-5.53-.26-11.06-.46-16.59-.62Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134739",
    "data-name": "Path 134739",
    d: "M430.11,586.95v18.54h25.33v-19.08c-8.43,.37-16.88,.51-25.33,.53Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134740",
    "data-name": "Path 134740",
    d: "M657.02,658.97c-5.57-.1-11.11-.43-16.66-.85v17.05h25.33v-16.16c-2.89,.02-5.78,0-8.67-.04Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134741",
    "data-name": "Path 134741",
    d: "M675.41,658.89v16.28h25.33v-16.79c-8.44,.07-16.89,.34-25.33,.51Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134742",
    "data-name": "Path 134742",
    d: "M675.41,584.38v21.11h25.33v-21.64c-8.44-.14-16.89,.09-25.33,.52Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134743",
    "data-name": "Path 134743",
    d: "M465.15,585.84v19.66h25.33v-21.43c-8.46,.38-16.88,1.17-25.33,1.78Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134744",
    "data-name": "Path 134744",
    d: "M465.15,657.61v17.56h25.33v-18.44c-8.44,.46-16.88,.73-25.33,.88Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134745",
    "data-name": "Path 134745",
    d: "M500.19,656.13v19.05h25.33v-20.43c-8.45,.33-16.89,.79-25.33,1.38Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134746",
    "data-name": "Path 134746",
    d: "M535.24,584.88v20.62h25.33v-18.9c-8.44-.59-16.88-1.21-25.33-1.72Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134747",
    "data-name": "Path 134747",
    d: "M500.19,583.81v21.68h25.33v-21.14c-8.44-.4-16.88-.63-25.33-.54Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134748",
    "data-name": "Path 134748",
    d: "M535.24,654.42v20.75h25.33v-21.05c-8.44-.03-16.88,.06-25.33,.3Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1196",
    "data-name": "Line 1196",
    x1: 342.62,
    y1: 521.93,
    x2: 720.84,
    y2: 524.5,
    fill: "none",
    stroke: "#a15f39",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_134749",
    "data-name": "Path 134749",
    d: "M723.12,701.22l21.76,4.63-60.73-2.57-1.81-185.7h38.99l1.79,183.64Z",
    fill: "#000051",
    isolation: "isolate",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134750",
    "data-name": "Path 134750",
    d: "M377.1,874.24c-14.04-3.36-45.55-10.83-68.59-16.28,19.33-16.41-11.61-31.97-39.03-41.44-11.61-4.01-52.72-16.43-70.35-19.19-20.48-3.62-34.04-3.82-30.28-.47l.16,.32c-5.49-1.32-11.1-2.52-16.65-3.58-29.13-5.34-49.74-6.08-46.16-1.66,.67,1.25,3.08,2.8,6.99,4.5-29.85-4.84-48.94-4.96-45.1-.27,1.51,2.66,9.12,6.34,20.67,9.99-38.71-6.33-63.43-4.89-56.82,3.31,3.16,6.46,25.06,15.84,54.47,24.76-7.31-.4-12.37-.04-14.16,1.22-5.28,3.7,20.67,10.26,55.5,22.33,60.47,20.96,103.6,14.62,157.91,8.2,17.33,4.17,47.07,9.11,56.75,11.4,25.83,6.12,106.62,23.46,106.62,23.46l11.55-8.11s-62.98-13.61-83.48-18.52Z",
    fill: "#000051",
    isolation: "isolate",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67327",
    "data-name": "Group 67327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134751",
    "data-name": "Path 134751",
    d: "M470.88,900.85h-21.84s3.58-62.45,3.41-83.29c-.13-14.71,0-61.31,0-61.31l14.76,1.13s.51,58.25,.57,77.21c.05,16.59,3.11,66.27,3.11,66.27Z",
    fill: "#665049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134752",
    "data-name": "Path 134752",
    d: "M537.93,691.13c-2.61-15.46-8.74-23.82-13.66-18.67l-.57,.37c0-4.39-.29-8.77-.84-13.12-3.34-22.16-11.79-35.22-18.94-29.26-2.18,1.47-4.14,4.27-5.66,8.08-4.68-22.17-13.65-33.78-21.21-27.43-4.61,3.2-8.33,10.95-10.08,21.05-5.97-28.78-20.78-42.45-34.04-31.42-11.45,7.46-19.71,28.73-23.44,54.14-2.71-4.75-5.89-7.49-9.29-7.49-9.98,0-18.06,23.58-18.06,52.67,0,80.11,34.12,109.32,81.61,109.32s63.55-33.64,69.57-59.31c2.45-10.45,7.55-45.91,4.6-58.93Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134753",
    "data-name": "Path 134753",
    d: "M400.29,701.16c-6.93,4.56-12.51,15.01-16.34,28.47,7.61,57.84,38.7,79.74,79.81,79.74,9.39,.13,18.72-1.51,27.51-4.84,.89-9.56,1.2-19.02,.01-24.29-2.27-13.52-7.57-20.83-11.83-16.33l-.5,.32c0-3.84-.25-7.67-.73-11.48-2.89-19.38-10.22-30.81-16.41-25.6-1.89,1.29-3.58,3.73-4.9,7.07-4.05-19.39-11.83-29.54-18.38-23.99-4,2.8-7.21,9.58-8.74,18.41-5.17-25.17-18-37.13-29.49-27.48Z",
    fill: "#336545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67328",
    "data-name": "Group 67328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134754",
    "data-name": "Path 134754",
    d: "M73.65,712.6h-11.59s1.9-33.14,1.81-44.19c-.07-7.8,0-32.53,0-32.53l7.83,.6s.27,30.91,.3,40.96c.03,8.8,1.65,35.16,1.65,35.16Z",
    fill: "#665049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134755",
    "data-name": "Path 134755",
    d: "M109.23,601.32c-1.39-8.2-4.64-12.64-7.25-9.9l-.3,.2c0-2.33-.15-4.65-.45-6.96-1.77-11.76-6.26-18.69-10.05-15.53-1.39,1.11-2.44,2.6-3,4.29-2.48-11.76-7.24-17.92-11.25-14.55-2.45,1.7-4.42,5.81-5.35,11.17-3.17-15.27-11.03-22.52-18.06-16.67-6.07,3.96-10.46,15.24-12.44,28.72-1.44-2.52-3.12-3.97-4.93-3.97-5.29,0-9.58,12.51-9.58,27.95,0,42.51,18.1,58,43.3,58s33.72-17.85,36.91-31.47c1.3-5.55,4-24.37,2.44-31.27Z",
    fill: "#336545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67329",
    "data-name": "Group 67329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134756",
    "data-name": "Path 134756",
    d: "M1871,712.6h-11.59s1.9-33.14,1.81-44.19c-.07-7.8,0-32.53,0-32.53l7.83,.6s.27,30.91,.3,40.96c.03,8.8,1.65,35.16,1.65,35.16Z",
    fill: "#665049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134757",
    "data-name": "Path 134757",
    d: "M1906.58,601.32c-1.39-8.2-4.64-12.64-7.25-9.9l-.3,.2c0-2.33-.15-4.65-.45-6.96-1.77-11.76-6.26-18.69-10.05-15.53-1.39,1.11-2.44,2.6-3,4.29-2.48-11.76-7.24-17.92-11.26-14.55-2.45,1.7-4.42,5.81-5.35,11.17-3.17-15.27-11.03-22.52-18.06-16.67-6.07,3.96-10.46,15.24-12.44,28.72-1.44-2.52-3.12-3.97-4.93-3.97-5.29,0-9.58,12.51-9.58,27.95,0,42.51,18.1,58,43.3,58s33.72-17.85,36.91-31.47c1.3-5.55,4-24.37,2.44-31.27Z",
    fill: "#336545"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_134758",
    "data-name": "Path 134758",
    d: "M569.39,859.48l5.95-27.74,8.26,20.81,8.95-26.75,2.97,23.78,8.92-15.85,6.94,15.85,13.87-27.74,2.97,32.7,12.88-18.83,2.97,22.79-74.68,.99Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134759",
    "data-name": "Path 134759",
    d: "M1341.44,937.48l8.15-38.05,11.32,28.54,12.28-36.69,4.08,32.61,12.23-21.74,9.51,21.74,19.03-38.05,4.08,44.84,17.67-25.82,4.08,31.26-102.42,1.36Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134760",
    "data-name": "Path 134760",
    d: "M184.8,767.34l4.54-21.17,6.3,15.88,6.83-20.42,2.27,18.15,6.8-12.1,5.29,12.1,10.59-21.17,2.27,24.95,9.83-14.37,2.27,17.39-56.99,.75Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134761",
    "data-name": "Path 134761",
    d: "M1513.64,715.81l4.07-18.98,5.65,14.24,6.13-18.3,2.03,16.27,6.1-10.85,4.74,10.85,9.49-18.98,2.03,22.37,8.81-12.88,2.03,15.59-51.1,.67Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134762",
    "data-name": "Path 134762",
    d: "M1691.24,936.97c-16.38-4.44-53.16-14.32-80.05-21.55,23.07-19.57-12.85-39.32-44.78-51.55-13.53-5.18-61.43-21.34-82.05-25.14-23.93-4.91-39.83-5.49-35.5-1.31l.18,.4c-6.41-1.74-12.95-3.34-19.45-4.77-34.04-7.22-58.2-8.62-54.1-3.14,.75,1.54,3.55,3.5,8.09,5.66-34.9-6.64-57.28-7.24-52.89-1.42,1.71,3.29,10.55,7.96,24,12.7-45.25-8.66-74.27-7.5-66.72,2.67,3.55,7.97,29.01,19.95,63.29,31.56-8.56-.67-14.5-.34-16.64,1.15-6.28,4.4,21.98,19.95,64.56,28.61,85.93,17.49,145.08,17.66,183.01,12.79,20.22,5.51,60.74,15.76,72.03,18.79,30.15,8.1,120.74,28.78,120.74,28.78l13.74-9.62s-73.54-18.14-97.48-24.62Z",
    fill: "#000051",
    isolation: "isolate",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67330",
    "data-name": "Group 67330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134763",
    "data-name": "Path 134763",
    d: "M1795.84,971.18h-26.14s4.29-74.76,4.08-99.71c-.15-17.61,0-73.39,0-73.39l17.67,1.36s.61,69.73,.68,92.42c.06,19.85,3.72,79.32,3.72,79.32Z",
    fill: "#665049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134764",
    "data-name": "Path 134764",
    d: "M1876.12,720.13c-3.13-18.51-10.46-28.51-16.35-22.35l-.68,.44c0-5.25-.34-10.5-1.01-15.71-3.99-26.52-14.12-42.16-22.67-35.03-2.61,1.76-4.95,5.11-6.77,9.67-5.6-26.54-16.34-40.43-25.39-32.84-5.52,3.83-9.97,13.11-12.07,25.2-7.15-34.46-24.88-50.82-40.74-37.62-13.7,8.93-23.59,34.39-28.06,64.81-3.25-5.69-7.05-8.97-11.11-8.97-11.94,0-21.62,28.23-21.62,63.05,0,95.9,40.84,130.86,97.7,130.86s76.08-40.27,83.28-71c2.93-12.51,9.03-54.96,5.5-70.53Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134765",
    "data-name": "Path 134765",
    d: "M1711.35,732.13c-8.29,5.46-14.97,17.97-19.56,34.08,9.11,69.24,46.32,95.45,95.54,95.45,11.24,.16,22.41-1.81,32.93-5.79,1.06-11.44,1.43-22.77,.02-29.08-2.71-16.19-9.07-24.94-14.17-19.55l-.59,.39c0-4.59-.3-9.18-.88-13.74-3.46-23.2-12.23-36.88-19.64-30.64-2.26,1.54-4.29,4.47-5.87,8.46-4.85-23.21-14.16-35.37-22-28.72-4.79,3.35-8.64,11.47-10.46,22.04-6.2-30.14-21.56-44.45-35.31-32.9Z",
    fill: "#336545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67332",
    "data-name": "Group 67332"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67331",
    "data-name": "Group 67331"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_360",
    "data-name": "Ellipse 360",
    cx: 1099.09,
    cy: 1138.84,
    rx: 741.5,
    ry: 176.49,
    fill: "#75a0aa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67506",
    "data-name": "Group 67506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Beredskab"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67500",
    "data-name": "Group 67500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67499",
    "data-name": "Group 67499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134843",
    "data-name": "Path 134843",
    d: "M1196.23,722.02l-50.23,1.6v-75.69h50.23v74.09Z",
    fill: "#2e4359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134844",
    "data-name": "Path 134844",
    d: "M1201.82,722.02l-50.23,1.6v-75.69h50.23v74.09Z",
    fill: "#435a7f"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19419",
    "data-name": "Rectangle 19419",
    x: 1158.9,
    y: 655.85,
    width: 34.25,
    height: 3.53,
    fill: "#95a8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19420",
    "data-name": "Rectangle 19420",
    x: 1158.9,
    y: 663.61,
    width: 26.11,
    height: 3.53,
    fill: "#95a8bf"
  })))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Light",
    cx: 1038,
    cy: 652.28,
    rx: 235,
    ry: 152,
    fill: "url(#radial-gradient-2)",
    isolation: "isolate",
    opacity: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18995",
    "data-name": "Rectangle 18995",
    x: 0,
    width: 1921.98,
    height: 1082.28,
    fill: "url(#radial-gradient-3)",
    isolation: "isolate",
    opacity: 0.2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clouds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134766",
    "data-name": "Path 134766",
    d: "M288.85,114.46c-6.3-.04-12.42,2.04-17.39,5.91,.17-1.35,.26-2.7,.26-4.06,0-19.6-17.5-35.5-39.08-35.5-9.98-.08-19.64,3.48-27.19,10.01-6.21-24.56-30.41-42.88-59.33-42.88s-55.03,19.8-59.98,45.82c-5.35-3.82-11.77-5.86-18.35-5.82-16.28,0-29.48,11.99-29.48,26.77v.07c-3.45-1.33-7.12-2.02-10.82-2.01-15.19,0-27.51,11.19-27.51,24.99s12.32,24.99,27.51,24.99H288.85c14.68,0,26.58-10.81,26.58-24.14s-11.9-24.14-26.58-24.14Z",
    fill: "#bee0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134767",
    "data-name": "Path 134767",
    d: "M296.42,161.73c-2.93-7.31-13.66-12.74-26.49-12.74-6.2-.09-12.33,1.32-17.87,4.1,.18-.93,.27-1.87,.27-2.82,0-13.59-17.98-24.61-40.15-24.61-10.86,0-20.7,2.65-27.93,6.94-6.38-17.02-31.24-29.72-60.95-29.72s-56.54,13.73-61.62,31.77c-5.9-2.74-12.34-4.12-18.85-4.04-16.73,0-30.28,8.31-30.28,18.56v.04c-3.33-.85-6.75-1.31-10.18-1.36,4.27,8.77,13.93,14.89,25.16,14.89H288.85c2.56,0,5.1-.34,7.57-1.01Z",
    fill: "#8ec4d6",
    isolation: "isolate",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134768",
    "data-name": "Path 134768",
    d: "M251.51,115.33c-5.48-.03-10.81,1.78-15.14,5.15,.15-1.17,.23-2.36,.23-3.54,0-17.07-15.24-30.91-34.03-30.91-8.69-.07-17.1,3.03-23.67,8.72-5.41-21.38-26.47-37.33-51.66-37.33s-47.91,17.24-52.22,39.9c-4.66-3.33-10.25-5.1-15.97-5.07-14.17,0-25.66,10.44-25.66,23.31v.06c-3-1.16-6.2-1.76-9.42-1.75C10.73,113.86,0,123.6,0,135.61s10.72,21.76,23.95,21.76H251.51c12.78,0,23.14-9.41,23.14-21.02s-10.36-21.02-23.14-21.02Z",
    fill: "#bee0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134769",
    "data-name": "Path 134769",
    d: "M258.09,156.49c-2.55-6.37-11.9-11.09-23.07-11.09-5.4-.08-10.73,1.14-15.56,3.57,.15-.81,.23-1.63,.23-2.45,0-11.83-15.65-21.43-34.96-21.43-9.46,0-18.03,2.3-24.32,6.04-5.56-14.82-27.2-25.88-53.07-25.88s-49.23,11.95-53.66,27.66c-5.14-2.39-10.75-3.59-16.41-3.52-14.56,0-26.37,7.24-26.37,16.16v.04c-2.9-.74-5.88-1.14-8.87-1.19,3.72,7.63,12.13,12.96,21.91,12.96H251.5c2.23,0,4.44-.3,6.59-.88Z",
    fill: "#8ec4d6",
    isolation: "isolate",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134772",
    "data-name": "Path 134772",
    d: "M189.65,272.05c-4.13-.02-8.16,1.34-11.42,3.88,.11-.88,.17-1.78,.17-2.67,0-12.87-11.49-23.31-25.66-23.31-6.55-.05-12.9,2.29-17.85,6.57-4.08-16.12-19.96-28.15-38.95-28.15s-36.13,13-39.38,30.09c-3.51-2.51-7.73-3.85-12.04-3.82-10.69,0-19.35,7.87-19.35,17.58v.04c-2.26-.88-4.67-1.32-7.1-1.32C8.09,270.94,0,278.29,0,287.34s8.09,16.4,18.06,16.4H189.65c9.64,0,17.45-7.1,17.45-15.85s-7.81-15.84-17.45-15.84Z",
    fill: "#bee0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134773",
    "data-name": "Path 134773",
    d: "M194.62,303.09c-1.92-4.8-8.97-8.37-17.39-8.37-4.07-.06-8.09,.86-11.73,2.69,.12-.61,.18-1.23,.18-1.85,0-8.92-11.8-16.16-26.37-16.16-6.41-.12-12.73,1.45-18.34,4.56-4.19-11.18-20.51-19.52-40.02-19.52s-37.12,9.01-40.46,20.86c-3.87-1.8-8.1-2.71-12.38-2.65-10.98,0-19.88,5.45-19.88,12.18v.03c-2.19-.56-4.43-.86-6.69-.9,3.2,6.13,9.6,9.92,16.52,9.77H189.65c1.68,0,3.35-.22,4.97-.65Z",
    fill: "#8ec4d6",
    isolation: "isolate",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134774",
    "data-name": "Path 134774",
    d: "M189.65,297.37c-4.13-.02-8.16,1.34-11.42,3.88,.11-.88,.17-1.78,.17-2.67,0-12.87-11.49-23.31-25.66-23.31-6.55-.05-12.9,2.29-17.85,6.57-4.08-16.12-19.96-28.15-38.95-28.15s-36.13,13-39.38,30.09c-3.51-2.51-7.73-3.85-12.05-3.83-10.69,0-19.35,7.87-19.35,17.58v.04c-2.26-.88-4.67-1.32-7.1-1.32C8.09,296.26,0,303.61,0,312.66s8.09,16.4,18.06,16.4H189.66c9.64,0,17.45-7.1,17.45-15.85s-7.82-15.84-17.46-15.84Z",
    fill: "#bee0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134775",
    "data-name": "Path 134775",
    d: "M194.62,328.41c-1.92-4.8-8.97-8.37-17.4-8.37-4.07-.06-8.09,.86-11.73,2.69,.12-.61,.18-1.23,.18-1.85,0-8.92-11.8-16.16-26.36-16.16-6.41-.12-12.73,1.45-18.34,4.56-4.19-11.18-20.51-19.52-40.02-19.52s-37.12,9.01-40.46,20.86c-3.87-1.8-8.1-2.71-12.38-2.65-10.98,0-19.88,5.45-19.88,12.18v.03c-2.19-.56-4.43-.86-6.69-.89,3.2,6.13,9.6,9.92,16.52,9.77H189.65c1.68,0,3.35-.22,4.97-.66Z",
    fill: "#8ec4d6",
    isolation: "isolate",
    opacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGame1);
export default __webpack_public_path__ + "static/media/login-game1.aa188b11202ab7fbdcf3c8ef2fd6c647.svg";
export { ForwardRef as ReactComponent };